import { Component, Input } from '@angular/core'
import { DatePipe } from '@angular/common'
import { TransactionDetails } from '../../models'

@Component({
    selector: 'ach-authorization-details',
    standalone: true,
    imports: [DatePipe],
    templateUrl: './authorization-details.component.html',
    styleUrl: './authorization-details.component.scss',
})
export class AuthorizationDetailsComponent {
    @Input({ required: true }) details!: TransactionDetails

    get isEmpty(): boolean {
        return !this.details.authorizationType && !this.details.authorizationDateTime
    }
}
